export default "https://assets.pclncdn.com/web/next-landing/49d3d019e1/_next/static/images/new-york-city-e3ea07bac02abf8249fa015449241d8e.webp";